module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/fraternity-share-image-c4cec442800f288768c8c73f306ca6f5.jpg";